/**
 * Shared route path segments used across all ERP apps.
 * Values do NOT include a leading slash (e.g. 'account-credentials').
 * Use as <Route path={RouteLink.AccountCredentials}> directly,
 * or prefix with '/' when building a full path (e.g. '/' + RouteLink.AccountCredentials).
 */
export const SharedRouteLink = {
    Home: '/',
    AccountCredentials: 'account-credentials',
    General: 'general',
    Users: 'users',
    CustomersAndProjects: 'customers-and-projects',
    Expenses: 'expenses',
    Payables: 'payables',
    Review: 'review',
} as const;